//导入store
import store from "@/store";
export default {
  inserted(el, bindling) {
    //bindling.value为指令的绑定值
    let perVal = bindling.value;
    if (bindling.value) {
      const tags = store.getters.tags;
      let hasPer = tags.some(item => {
        return item == perVal;
      });
      if (!hasPer) {
        el.style.display = "none";
      }
    }
  }
};
